// Webhooks – Menüeinträge für die Shell (Integrator bindet sie in extras/index.tsx ein).
import { Permissions } from '@lagerfeuer/shared';
import type { ExtraMenuItem } from '../index';
import { ServerWebhooksSettings } from './ServerWebhooksSettings';

export { ServerWebhooksSettings };

export const webhooksMenuItems: ExtraMenuItem[] = [
  { id: 'webhooks', label: 'Webhooks', slot: 'serverSettings', component: ServerWebhooksSettings, display: 'tab', serverPermission: Permissions.MANAGE_WEBHOOKS },
];
